// Wix site fullscreen mode: This is called from fullscreen.html
// implemented as a hidden page in the site
import React from 'react';
import ReactDOM from 'react-dom';
import { Wix, window } from '@wix/photography-client-lib';

import { ProFullscreenTPAWrapper } from '@wix/pro-fullscreen-tpa-wrapper';
import OldEditorNotice from './oldEditorNotice';
import { utils } from '../../utils';
import '../../utils/rcp';

$(window.document).ready(() => {
  // TURBO: id selector should be replaced by a class selector
  const content = window.document.getElementById('fullscreen');
  if (content) {
    let Fullscreen = OldEditorNotice;
    const isNewEditor = getIsNewEditor();
    if (isNewEditor !== false) {
      Fullscreen = getProFullscreen();
    }
    ReactDOM.render(<Fullscreen />, content);
  }
});

function getProFullscreen() {
  return (props) => <ProFullscreenTPAWrapper {...props} />;
}

function getIsNewEditor() {
  let isNewEditor = true;
  if (utils.isInWix()) {
    try {
      Wix.Features.isSupported(
        Wix.Features.Types.ADD_COMPONENT,
        (isWixNewEditor) => (isNewEditor = isWixNewEditor),
      );
    } catch (e) {}
  }
  return isNewEditor;
}
